import { useTranslation } from 'react-i18next';
import { useCompany } from '../../contexts/CompanyContext';

export function CompanySwitcher() {
  const { t } = useTranslation();
  const { activeCompany, companies, setActiveCompany, isLoading } = useCompany();

  if (isLoading) {
    return (
      <div className="flex h-8 items-center rounded-md border border-blue-700 px-3 text-xs text-blue-300 dark:border-gray-600 dark:text-gray-400">
        {t('common.loading')}
      </div>
    );
  }

  if (companies.length === 0) {
    return (
      <div className="flex h-8 items-center rounded-md border border-blue-700 px-3 text-xs text-blue-300 dark:border-gray-600 dark:text-gray-400">
        {t('company.noCompanySelected')}
      </div>
    );
  }

  return (
    <div className="relative flex items-center gap-2">
      <select
        value={activeCompany?.id ?? ''}
        onChange={(e) => setActiveCompany(e.target.value)}
        className="h-8 rounded-md border border-blue-700 bg-blue-900 px-2 pr-7 text-xs text-blue-100 transition-colors hover:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:hover:border-gray-400"
        aria-label={t('company.selectCompany')}
      >
        {!activeCompany && (
          <option value="" disabled>
            {t('company.selectCompany')}
          </option>
        )}
        {companies.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
      {activeCompany && (
        <span className="hidden rounded bg-blue-800 px-1.5 py-0.5 text-xs font-mono text-blue-300 dark:bg-gray-800 dark:text-gray-400 sm:inline">
          {activeCompany.code}
        </span>
      )}
    </div>
  );
}
